import { Stack, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { Fragment, SyntheticEvent, useCallback, useMemo, useState } from 'react'
import { EOp, FilterModelText, Nullish, Option, UserType, UserTypeLabels } from 'types'

interface UserTypeOption {
  value: UserType
  label: string
}

const userTypeOptions: UserTypeOption[] = [
  { value: UserType.TRAINEE, label: UserTypeLabels[UserType.TRAINEE] },
  { value: UserType.CAREGIVER, label: UserTypeLabels[UserType.CAREGIVER] },
]

export function useUserTypeFilter() {
  const [userTypeValue, setUserTypeValue] = useState<UserTypeOption[]>([])

  const userTypeFilterValue: Nullish<{ userType: FilterModelText }> = useMemo(() => {
    if (userTypeValue.length > 0) {
      return {
        userType: {
          type: 'text',
          op: EOp.overlap,
          value: userTypeValue.map((item) => item.value),
        } as FilterModelText,
      }
    }

    return null
  }, [userTypeValue])

  const handleChange = useCallback((_: SyntheticEvent, newValue: Option[]) => {
    setUserTypeValue(newValue as UserTypeOption[])
  }, [])

  const UserTypeFilter = useMemo(() => {
    return (
      <Stack direction="row" alignItems="center" className="gap-8">
        <Typography flexShrink={0}>User Type</Typography>

        <Autocomplete
          multiple
          options={userTypeOptions}
          value={userTypeValue}
          onChange={handleChange}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              name="userType"
              InputProps={{
                ...params.InputProps,
                endAdornment: <Fragment>{params.InputProps.endAdornment}</Fragment>,
              }}
            />
          )}
        />
      </Stack>
    )
  }, [handleChange, userTypeValue])

  return { UserTypeFilter, userTypeFilterValue }
}
